export const RESTAURANTS_GET_REQUEST = 'RESTAURANTS_GET_REQUEST';
export const RESTAURANTS_GET_SUCCESS = 'RESTAURANTS_GET_SUCCESS';
export const RESTAURANTS_GET_FAILURE = 'RESTAURANTS_GET_FAILURE';

export const RESTAURANTS_GET_SELECTED_REQUEST = 'RESTAURANTS_GET_SELECTED_REQUEST';
export const RESTAURANTS_GET_SELECTED_SUCCESS = 'RESTAURANTS_GET_SELECTED_SUCCESS';
export const RESTAURANTS_GET_SELECTED_FAILURE = 'RESTAURANTS_GET_SELECTED_FAILURE';

export const RESTAURANTS_RESET_LIST_DATA = 'RESTAURANTS_RESET_LIST_DATA';

export const RESTAURANT_BY_ID_GET_REQUEST = 'RESTAURANT_BY_ID_GET_REQUEST';
export const RESTAURANT_BY_ID_GET_SUCCESS = 'RESTAURANT_BY_ID_GET_SUCCESS';
export const RESTAURANT_BY_ID_GET_FAILURE = 'RESTAURANT_BY_ID_GET_FAILURE';

export const RESTAURANT_CREATE_REQUEST = 'RESTAURANT_CREATE_REQUEST';
export const RESTAURANT_CREATE_SUCCESS = 'RESTAURANT_CREATE_SUCCESS';
export const RESTAURANT_CREATE_FAILURE = 'RESTAURANT_CREATE_FAILURE';

export const RESTAURANT_UPDATE_REQUEST = 'RESTAURANT_UPDATE_REQUEST';
export const RESTAURANT_UPDATE_SUCCESS = 'RESTAURANT_UPDATE_SUCCESS';
export const RESTAURANT_UPDATE_FAILURE = 'RESTAURANT_UPDATE_FAILURE';

export const RESTAURANT_CREATE_OR_UPDATE_REQUEST = 'RESTAURANT_CREATE_OR_UPDATE_REQUEST';
export const RESTAURANT_CREATE_OR_UPDATE_SUCCESS = 'RESTAURANT_CREATE_OR_UPDATE_SUCCESS';
export const RESTAURANT_CREATE_OR_UPDATE_FAILURE = 'RESTAURANT_CREATE_OR_UPDATE_FAILURE';

export const RESTAURANT_DELETE_REQUEST = 'RESTAURANT_DELETE_REQUEST';
export const RESTAURANT_DELETE_SUCCESS = 'RESTAURANT_DELETE_SUCCESS';
export const RESTAURANT_DELETE_FAILURE = 'RESTAURANT_DELETE_FAILURE';

export const USERS_BULK_CREATE_REQUEST = 'USERS_BULK_CREATE_REQUEST';
export const USERS_BULK_CREATE_SUCCESS = 'USERS_BULK_CREATE_SUCCESS';
export const USERS_BULK_CREATE_FAILURE = 'USERS_BULK_CREATE_FAILURE';
